import api from '@/apis'
import * as TYPES from './mutationTypes'

export default {
  getUserSystemLists({ commit }, params) {
    return api.system
      .getUserList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_USER_LIST, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  },
  getRoleLists({ commit }, params) {
    return api.system
      .getRoleList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_ROLE_LIST, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  }
}
